"use strict";

require("core-js/modules/es6.object.define-property");

var _d = require("d3");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.getNeedleTransition = getNeedleTransition;

function getNeedleTransition(a) {
  switch (a) {
    case "easeLinear":
      return _d.easeLinear;
      break;

    case "easeQuadIn":
      return _d.easeQuadIn;
      break;

    case "easeQuadOut":
      return _d.easeQuadOut;
      break;

    case "easeQuadInOut":
      return _d.easeQuadInOut;
      break;

    case "easeCubicIn":
      return _d.easeCubicIn;
      break;

    case "easeCubicOut":
      return _d.easeCubicOut;
      break;

    case "easeCubicInOut":
      return _d.easeCubicInOut;
      break;

    case "easePolyIn":
      return _d.easePolyIn;
      break;

    case "easePolyOut":
      return _d.easePolyOut;
      break;

    case "easePolyInOut":
      return _d.easePolyInOut;
      break;

    case "easeSinIn":
      return _d.easeSinIn;
      break;

    case "easeSinOut":
      return _d.easeSinOut;
      break;

    case "easeSinInOut":
      return _d.easeSinInOut;
      break;

    case "easeExpIn":
      return _d.easeExpIn;
      break;

    case "easeExpOut":
      return _d.easeExpOut;
      break;

    case "easeExpInOut":
      return _d.easeExpInOut;
      break;

    case "easeCircleIn":
      return _d.easeCircleIn;
      break;

    case "easeCircleOut":
      return _d.easeCircleOut;
      break;

    case "easeCircleInOut":
      return _d.easeCircleInOut;
      break;

    case "easeBounceIn":
      return _d.easeBounceIn;
      break;

    case "easeBounceOut":
      return _d.easeBounceOut;
      break;

    case "easeBounceInOut":
      return _d.easeBounceInOut;
      break;

    case "easeBackIn":
      return _d.easeBackIn;
      break;

    case "easeBackOut":
      return _d.easeBackOut;
      break;

    case "easeBackInOut":
      return _d.easeBackInOut;
      break;

    case "easeElasticIn":
      return _d.easeElasticIn;
      break;

    case "easeElasticOut":
      return _d.easeElasticOut;
      break;

    case "easeElasticInOut":
      return _d.easeElasticInOut;
      break;

    case "easeElastic":
      return _d.easeElastic;
      break;

    case "easeElastic":
      return _d.easeElastic;
      break;

    default:
      return _d.easeQuadInOut;
  }
}